(function () {
  'use strict';

  var STORAGE_KEY = 'splash-screen-seen';
  var SEEN_CLASS = 'splash-screen-seen';

  function markSeen() {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {}
  }

  function hide() {
    document.documentElement.classList.add(SEEN_CLASS);
    var b2bModal = document.querySelector('#B2BWelcomeModal');
    if (!b2bModal || !b2bModal.hasAttribute('open')) {
      document.body.classList.remove('overflow-hidden');
    }
    markSeen();
  }

  function init() {
    var splash = document.getElementById('SplashScreen');
    if (!splash) return;

    var designMode = !!(window.Shopify && Shopify.designMode);
    var params = new URLSearchParams(window.location.search);

    if (params.get('test-splash') === '1') {
      document.documentElement.classList.remove(SEEN_CLASS);
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
    }

    var visible = designMode || !document.documentElement.classList.contains(SEEN_CLASS);

    if (visible) {
      document.body.classList.add('overflow-hidden');
    }

    splash.addEventListener('click', function (event) {
      var button = event.target.closest('[data-splash-action]');
      if (!button) return;

      if (button.getAttribute('data-splash-action') === 'redirect') {
        redirect(button);
      } else {
        hide();
      }
    });

    // Coming back via the browser's back button restores this page from cache
    // with the splash still showing and the button still loading.
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      splash.querySelectorAll('[aria-busy="true"]').forEach(function (button) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
      if (!designMode) hide();
    });
  }

  // Keep the splash on screen while navigating away. Hiding it first briefly
  // revealed (and reflowed) the page underneath, which looked like an error.
  function redirect(button) {
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    markSeen();

    var fallbackUrl = button.getAttribute('data-splash-url');
    var corp = window.corporateCustomisation;
    var ready = corp && corp.ready ? corp.ready : Promise.resolve(fallbackUrl);
    var timeout = new Promise(function (resolve) {
      setTimeout(resolve, 1500);
    });

    Promise.race([ready, timeout])
      .catch(function () {})
      .then(function () {
        // corporate-customisation.js updates data-splash-url once it knows the country.
        var url = button.getAttribute('data-splash-url') || fallbackUrl;
        if (url) {
          window.location.href = url;
        } else {
          hide();
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
